module.exports = __webpack_public_path__ + "static/media/sullied-sediments-interreg-nsr-vertical.b8d5a917.png";